export const scheduleDialogHeader = "uDc";
export const scheduleCancelButton = "vDc";
export const returnToSuggestions = "wDc";
export default {scheduleDialogHeader,scheduleCancelButton,returnToSuggestions};